import { useState } from 'react';
import styled from 'styled-components';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://qdcnjwgcrcrjbtwarvsx.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFkY25qd2djcmNyamJ0d2FydnN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg4OTMyMzAsImV4cCI6MjA4NDQ2OTIzMH0.XbzOlcw5knOUX1Kxhg1_hFHfcWh8RAgnad-fEfFvMqY'
);

const Page = styled.div`
  min-height: 100svh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  font-family: monospace;
  padding: 2rem 1rem;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 400px;
`;

const Form = styled.form`
  display: flex;
  width: 100%;
  border: 2px solid #0013FF;
  border-radius: 6px;
  overflow: hidden;
  background: white;
`;

const Input = styled.input`
  flex: 1;
  padding: 1rem;
  border: none;
  outline: none;
  font-size: 1rem;
  color: #0013FF;
  background: white;

  &::placeholder {
    color: #999;
  }
`;

const Button = styled.button`
  padding: 1rem 1.25rem;
  background: #0013FF;
  color: white;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #000ecb;
  }
`;

const Message = styled.p`
  color: #0013FF;
  text-align: center;
`;

export default function EmailCapture() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const submit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(email)) {
      alert('Please enter a valid email address.');
      return;
    }

    const { error } = await supabase.from('emails').insert({ email });

    if (!error) {
      setDone(true);
    } else {
      alert(error.message);
    }
  };

  return (
    <Page>
      <Wrapper>
        {!done ? (
          <Form onSubmit={submit}>
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button type="submit">Submit</Button>
          </Form>
        ) : (
          <Message>You are on the list.</Message>
        )}
      </Wrapper>
    </Page>
  );
}
